import { CandidateResumePage } from '@pages/candidate/candidate-resume';
import { createMeta } from '@shared/utils';

export function meta() {
  return createMeta(
    'Детальная страница кандидата',
    'Детальная страница кандидата'
  );
}

export default CandidateResumePage;
